import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Slice, Fragment, Node } from '@tiptap/pm/model';
import { v4 as uuidv4 } from 'uuid';

const pastePluginKey = new PluginKey('handleTablePaste');

export const createTablePastePlugin = () => {
  return new Plugin({
    key: pastePluginKey,
    props: {
      transformPasted(slice) {
        const fragment = wrapTablesInFragment(slice.content);
        return new Slice(fragment, slice.openStart, slice.openEnd);
      },
    },
  });
};

const wrapInTableFigureNode = (node: Node) => {
  const schema = node.type.schema;
  const tableFigureType = schema.nodes.tableFigure;
  const figcaptionType = schema.nodes.figcaption;
  const paragraphType = schema.nodes.paragraph;

  const emptyParagraph = paragraphType.create({ id: uuidv4() }, []);
  const topFigcaption = figcaptionType.create(null, emptyParagraph);
  const bottomFigcaption = figcaptionType.create(null, paragraphType.create({ id: uuidv4() }, []));

  const wrappedTable = tableFigureType.create({ id: uuidv4() }, [topFigcaption, node, bottomFigcaption]);
  return wrappedTable;
};

const getAllContentFromTableRow = (node: Node): Node[] => {
  const content: Node[] = [];
  node.forEach((cell) => {
    cell.forEach((childNode) => {
      content.push(childNode);
    });
  });

  return content;
};

const wrapTablesInFragment = (fragment: Fragment): Fragment => {
  const nodes: any[] = [];

  fragment.forEach((node) => {
    if (node.type.name === 'table') {
      nodes.push(wrapInTableFigureNode(node));
    } else if (node.type.name === 'tableRow') {
      // Extract content from all cells in the row and add them directly
      const rowContent = getAllContentFromTableRow(node);
      nodes.push(...rowContent);
    } else {
      nodes.push(node);
    }
  });

  return Fragment.fromArray(nodes);
};
